module.exports = __webpack_public_path__ + "static/img/org.png";